import { Dialog, DialogContent, DialogTitle, Divider, Grid, Typography, useTheme } from "@mui/material";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { IStore } from "../../store/IStore";
import { CustomerHistoryDto } from "../../store/models/history/HistoryDto";
import { dialogStyles } from "../atoms/DialogStyle";
import { COLOR_GRAY_1 } from "../atoms/ImsMaterialTheme";
import { formatGermanDateTime } from "../atoms/Utils";
import NotificationList from "../notification/NotificationList";
import { useTranslation } from "react-i18next";

interface NoteDialogProps extends ThunkProps {
  note: CustomerHistoryDto;
  setNoteDialogVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const noteOf = (action: CustomerHistoryDto) => action.interaction?.note ?? action.note;
const usernameOf = (action: CustomerHistoryDto) => action.interaction?.username ?? action.username;

export const hasNoteDialog = (action: CustomerHistoryDto) => noteOf(action) || usernameOf(action);

const NoteDialog = (props: NoteDialogProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Dialog
      onClose={() => props.setNoteDialogVisible(false)}
      open={true}
      fullWidth={false}
      maxWidth="sm"
      PaperProps={{
        sx: dialogStyles.scrollIn,
      }}
    >
      <NotificationList isDialog />
      <DialogTitle style={{ padding: theme.spacing(0) }}>
        <Grid container style={{ padding: theme.spacing(3) }}>
          <b>{t("noteDialog.title")}</b>
        </Grid>

        <Divider
          style={{
            color: COLOR_GRAY_1,
            height: "2px",
          }}
          light={true}
        />

        <Grid container style={{ padding: theme.spacing(3) }}>
          <Grid item sm={6}>
            <Typography variant="subtitle1">{t("noteDialog.labelDateTime")}</Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography variant="body1">{formatGermanDateTime(new Date(props.note.eventTimestamp))}</Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography variant="subtitle1">{t("noteDialog.labelUsername")}</Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography variant="body1">{usernameOf(props.note) || "-"}</Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <Divider
        style={{
          color: COLOR_GRAY_1,
          height: "2px",
        }}
        light={true}
      />
      <DialogContent
        style={{
          padding: theme.spacing(0),
          overflow: "hidden",
          display: "flex",
        }}
      >
        {noteOf(props.note) ? (
          <Grid container style={{ padding: theme.spacing(3) }}>
            <Grid item sm={6}>
              <Typography variant="subtitle1">{t("noteDialog.labelNote")}</Typography>
            </Grid>
            <Grid item sm={6}>
              <Typography variant="body1">{noteOf(props.note)}</Typography>
            </Grid>
          </Grid>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = (_state: IStore) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({}, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(NoteDialog);
